import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState, TypedDispatch } from 'redux/store'
import nudgeTrackingSlice from './nudge-tracking-slice'

const useNudgeTracking = () => {
  const dispatch = useDispatch<TypedDispatch<RootState>>()
  const nudgeTracking = useSelector((state: RootState) => state.order.nudgeTracking)

  return useMemo(
    () => ({
      recurringNudge: {
        wasShown: nudgeTracking.recurringNudge.wasShown,
        wasAccepted: nudgeTracking.recurringNudge.wasAccepted,
        setShown: () => dispatch(nudgeTrackingSlice.actions.setRecurringNudgeShown()),
        setAccepted: (accepted: boolean) =>
          dispatch(nudgeTrackingSlice.actions.setRecurringNudgeAccepted(accepted)),
      },
      dcfNudge: {
        wasShown: nudgeTracking.dcfNudge.wasShown,
        wasAccepted: nudgeTracking.dcfNudge.wasAccepted,
        setShown: () => dispatch(nudgeTrackingSlice.actions.setDcfNudgeShown()),
        setAccepted: (accepted: boolean) =>
          dispatch(nudgeTrackingSlice.actions.setDcfNudgeAccepted(accepted)),
      },
    }),
    [dispatch, nudgeTracking],
  )
}

export default useNudgeTracking
